import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { CyclistService } from 'src/app/services/cyclist.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { CollectionsService } from '../../../../../services/collections.service';

@Component({
  selector: 'app-workshop-jobcard-create-customer',
  templateUrl: './workshop-jobcard-create-customer.component.html',
  styleUrls: ['./workshop-jobcard-create-customer.component.scss']
})
export class WorkshopJobcardCreateCustomerComponent {

  @Input() jobcard: any;
  @Input() searchTerm: string = '';
  @Input() searchType: string = '';
  @Output() customerSelected = new EventEmitter<any>();

  public customer: any = {};
  public updating: boolean = false;
  public loading: boolean = true;  

  public partner: any;
  public addressOptions: any;
  public collectionAddrssLoading: boolean;
  public addresses = [];
  public addressSearch: any;
  public fullAddress: string = "";
  public showAddressDetails: boolean = false;
  public showCustomerDetails: boolean = true;
  public address: any = {};
  public addManually: boolean = true;
  public street_no: string
  public street_address: string
  public city: string
  public country: string
  public postal_code: string
  public apartment: string
  public editing: boolean = false;
  public showAddressForm: boolean = false;
  public editingAddress: any = {};
  public errorLabel = "An address with this label already exists..";

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private userService: UserService,
    private cyclistService: CyclistService,
    private helpersService: HelpersService,
    private collectionsService: CollectionsService,
  ) {
    this.partner = this.helpersService.getPartnerData();
  }

  ngOnInit() {
    this.errorLabel = this.translate.instant('customer.addresses.label_already_exists');
    this.customer = {
      Name: '',
      Surname: '',
      Email: '',
      PhoneNumber: ''
    };

    if (this.searchTerm && this.searchTerm.length > 0) {
      this.customer[this.searchType == 'email' ? 'Email' : this.searchType == 'phone' ? 'PhoneNumber' : 'Name'] = this.searchTerm;
    }
  }


  isValidCustomer(): boolean {
    return this.customer && (this.cyclistService.isValidPhoneNumber(this.customer.PhoneNumber) || this.cyclistService.isValidEmail(this.customer.Email));
  }

  createCustomer() {
    if (this.isValidCustomer()) {
      this.updating = true;
      var data = {
        Name: this.customer.Name,
        Surname: this.customer.Surname,
        Email: this.customer.Email,
        PhoneNumber: this.customer.PhoneNumber,
        PartnerID: this.helpersService.getPartnerId(),
      }
      this.userService.createCustomerV2(data).subscribe((response) => {

        this.jobcard.customer = {
          ID: response.Data.ID,
          Name: response.Data.CustomerName,
          Surname: response.Data.CustomerSurname,
          Email: response.Data.CustomerEmail,
          PhoneNumber: response.Data.CustomerMobile
        };

        this.updating = false;
        this.activeModal.close({ ...this.jobcard });
      }, (err) => {
        this.updating = false;
        var error = err && err.error ? err.error : null;
        if (error && error.Message == "CUSTOMER_EXISTS" && error.Customer) {
          var existingCustomer = {
            ID: error.Customer.CyclistID,
            Name: error.Customer.CustomerName,
            Surname: error.Customer.CustomerSurname,
            Email: error.Customer.CustomerEmail,
            PhoneNumber: error.Customer.CustomerMobile
          }
          this.activeModal.close({ action: 'customerExists', existingCustomer: existingCustomer, newCustomer: data });
          return
        }
      });
    } else {

    }
  }


  createCustomerV3() {
    if (this.city) {
      if (this.city.length > 0) {
        this.addAddressManually();
      }
    }

    this.customer.Addresses = this.addresses;
    this.customer.Bike = [];
    this.customer.PartnerID = this.helpersService.getPartnerId();

    if (this.isValidCustomer()) {
      this.updating = true;

      var data = {
        Addresses: this.customer.Addresses,
        Item: this.customer.Bike,
        Name: this.customer.Name,
        Surname: this.customer.Surname,
        Email: this.customer.Email,
        PhoneNumber: this.customer.PhoneNumber,
        PartnerID: this.helpersService.getPartnerId(),
      };

      this.userService.createCustomerV3(data).subscribe((response) => {
        this.jobcard.customer = {
          ID: response.Data.ID,
          Name: response.Data.CustomerName,
          Surname: response.Data.CustomerSurname,
          Email: response.Data.CustomerEmail,
          PhoneNumber: response.Data.CustomerMobile
        };

        this.updating = false;
        this.activeModal.close({ ...this.jobcard });
        
      }, (err) => {
        this.updating = false;
        var error = err && err.error ? err.error : null;
        if (error && error.Message == "CUSTOMER_EXISTS" && error.Customer) {
          var existingCustomer = {
            ID: error.Customer.CyclistID,
            Name: error.Customer.CustomerName,
            Surname: error.Customer.CustomerSurname,
            Email: error.Customer.CustomerEmail,
            PhoneNumber: error.Customer.CustomerMobile
          }
          this.activeModal.close({ action: 'customerExists', existingCustomer: existingCustomer, newCustomer: data });
          return
        }
      });
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.createCustomer();
  }

  showSteps(step) {
    switch (step) {
      case "addressDetails":
        this.showAddressDetails = true;
        this.showCustomerDetails = false;
        this.addManually = true;
        this.showAddressForm = false;
        break;
      case "customerDetails":
        this.showAddressDetails = false;
        this.showCustomerDetails = true;
        break;
    }
  }







  search(address) {
    this.addressSearch = address.query;
    this.address.googlePlaceID = null;
    this.collectionsService
      .getAddressOptions(
        address.query,
        this.partner.Country === 'GB' && address.query.length <= 8
          ? 'GB'
          : '',
      )
      .subscribe((res) => {
        this.addressOptions = res.predictions.map((x) => {
          return { address: x.description, placeID: x.place_id };
        });
      });

  }

  onSelect(event) {

    this.collectionAddrssLoading = true;
    this.address.googlePlaceID = event.placeID;
    this.fullAddress = event.address;
    this.showAddressForm = true;

    this.collectionsService
      .getGooglePlaceInfo(this.address.googlePlaceID)
      .subscribe((placeInfo) => {
        this.setAddressInfo(placeInfo);
      });
    if (!event.placeID) {
      this.getAddressPlaceDetails(true);
    } else {
      //this.getLocationFromAddress(event.address);
    }

  }


  async getAddressPlaceDetails(locationFromAddress = false) {
    await this.collectionsService
      .getAddressOptions(this.fullAddress, `${0},${0}`)
      .subscribe((res) => {
        this.address.googlePlaceID =
          res.predictions && res.predictions.length > 0
            ? res.predictions[0].place_id
            : 'N/A';
        if (locationFromAddress && this.address.googlePlaceID) {
          //this.getLocationFromAddress(
          //  this.fullAddress
          //);
        }
      });
  }


  getLocationFromAddress(address, reset = true) {
    this.collectionsService
      .getLocationFromAddress(
        address +
        (this.partner.Country === 'GB' && this.addressSearch.length <= 8
          ? ', ' + this.addressSearch + ', UK'
          : ''),
      )
      .subscribe(async (res) => {
        // await this.getAddressPlaceDetails(true);
        console.log(res);
        return;

      });
  }

  setAddressInfo(placeInfo) {
    if (placeInfo) {
      var GooglePlace = JSON.parse(placeInfo).result;
      var addressDetails = {
        street_no: null,
        street_address: null,
        city: null,
        country: null,
        postal_code: null,
        latitude: null,
        longitude: null,
        name: "",
        apartment: this.apartment
      };
      if (GooglePlace && GooglePlace.address_components) {
        var street_no = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('street_number') > -1;
          })
          .pop();
        if (street_no) {
          addressDetails.street_no = street_no.long_name;
          this.street_no = street_no.long_name;
        }
        var street_address = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('route') > -1;
          })
          .pop();
        if (street_address) {
          addressDetails.street_address = street_address.long_name;
          this.street_address = street_address.long_name;
        }
        var city = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_town') > -1;
          })
          .pop();
        if (city) {
          addressDetails.city = city.long_name;
          this.city = city.long_name;
        }
        if (!city) {
          var city = GooglePlace.address_components
            .filter((x) => {
              return x.types.indexOf('locality') > -1;
            })
            .pop();
          if (city) {
            addressDetails.city = city.long_name;
            this.city = city.long_name;
          }
        }

        var country = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('country') > -1;
          })
          .pop();
        if (country) {
          addressDetails.country = country.long_name;
          this.country = country.long_name;
        }
        var postal_code = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_code') > -1;
          })
          .pop();
        if (postal_code) {
          addressDetails.postal_code = postal_code.long_name;
          this.postal_code = postal_code.long_name;
        }
        addressDetails.latitude = GooglePlace.geometry.location.lat;
        addressDetails.longitude = GooglePlace.geometry.location.lng;

        addressDetails.name = this.customer.AddressType;

        this.address.addressDetails = addressDetails;
        this.address.postalCode = addressDetails.postal_code;
        this.address.apartment = this.apartment;

        if (this.addManually) {
          this.addresses.push(addressDetails);
          this.showAddressForm = !this.showAddressForm;
        }


        if (this.addManually) {
          this.customer.AddressType = "";
          this.customer.Address = ""

          if (!this.updating) {
            this.cyclistService.saveCustomerAddresses(this.partner.ID, this.customer.ID,
              {
                UserID: this.customer.ID,
                IsDefault: this.customer.Addresses && this.customer.Addresses.length > 0 ? false : true,
                Name: addressDetails.name,
                Address_Line_1: addressDetails.street_no ? addressDetails.street_no + " " + addressDetails.street_address : addressDetails.street_address,
                Address_Line_2: "",
                City: addressDetails.city,
                State_Province_region: addressDetails.city,
                Postal_Code: addressDetails.postal_code,
                Country: addressDetails.country,
                Apartment: this.apartment
              }).subscribe((res) => {
                this.showAddressForm = !this.showAddressForm;
              });
          }
          else {

          }
        }


      }
    }
  }

  editAddress() {
    this.editingAddress.Name = this.customer.AddressType;
    this.editingAddress.Address_Line_1 = this.street_no ? this.street_no + " " + this.street_address : this.street_address;
    this.editingAddress.Address_Line_2 = "";
    this.editingAddress.City = this.city;
    this.editingAddress.State_Province_region = this.city;
    this.editingAddress.Country = this.country;
    this.editingAddress.Postal_Code = this.postal_code;
    this.editingAddress.Apartment = this.apartment;

    this.cyclistService.updateCustomerAddresses(this.helpersService.getPartnerId(), this.customer.ID,
      this.editingAddress
      , this.editingAddress.id).subscribe((res) => {
        this.customer.AddressType = "";
        this.customer.Address = "";
        this.street_no = "";
        this.street_address = "";
        this.city = "";
        this.country = "";
        this.postal_code = "";
        this.apartment = "";
        this.addManually = !this.addManually;
        this.editing = false;
        this.showAddressForm = false;
        this.getAddresses();
      });
  }

  getAddresses() {
    console.log("Getting addresses for customer ", this.customer.ID);
    this.cyclistService.getCustomerAddresses(this.helpersService.getPartnerId(), this.customer.ID).subscribe((res) => {
      this.addresses = [];
      this.loading = false;
      for (let i = 0; i < res.length; i++) {
        this.addresses.push({
          name: res[i].name,
          street_no: res[i].address_Line_1,
          street_address: res[i].address_Line_2,
          city: res[i].city,
          postal_code: res[i].postal_Code,
          country: res[i].country,
          id: res[i].id,
          apartment: res[i].apartment
        });
      }

    });
  }


  deleteAddresses(address) {
    //this.cyclistService.deleteCustomerAddresses(this.helpersService.getPartnerId(), this.customer.ID, address.id).subscribe((res) => {
      const index = this.addresses.findIndex(addr => addr.id === address.id);
      if (index > -1) {
        this.addresses.splice(index, 1);
      }
    //});
  }


  editAddresses(address) {
    this.updating = true;
    this.editing = true;
    this.addManually = !this.addManually;
    this.showAddressForm = true;

    this.customer.AddressType = address.name;
    //this.customer.Address = address.street_no ? address.street_no + " " + address.street_address : address.street_address;

    this.street_no = address.street_no.substring(0, address.street_no.indexOf(" "));
    this.street_address = address.street_no.substring(address.street_no.indexOf(" ") + 1);
    this.city = address.city;
    this.country = address.country;
    this.postal_code = address.postal_code;
    this.apartment = address.apartment;
    this.editingAddress = address;
  }


  defaultChanged(address, index) {
    console.log(address, index);
  }


  addAddressManually() {
    var addressDetails = {
      street_no: this.street_no,
      street_address: this.street_address,
      city: this.city,
      country: this.country,
      postal_code: this.postal_code,
      latitude: 0,
      longitude: 0,
      name: this.customer.AddressType,
      apartment: this.apartment
    };

    this.addresses.push(addressDetails);
    this.customer.AddressType = "";
    this.customer.Address = "";
    this.street_no = "";
    this.street_address = "";
    this.city = "";
    this.country = "";
    this.postal_code = "";
    this.apartment = "";
    this.addManually = true;
    this.showAddressForm = false;

  }


  validateManualAddress() {
    if (!this.street_address) this.street_address = "";
    if (!this.city) this.city = "";
    if (!this.customer.AddressType) this.customer.AddressType = "";

    return !((this.street_address.trim().length > 0) && (this.city.trim().length > 0) && (this.customer.AddressType.trim().length > 0) && this.validateAddressName());
  }

  validateAddressName() {
    if (this.editing) return true;

    var addressTypeTrimmed = this.customer.AddressType.trim().toLowerCase();
    return !this.addresses.some(addr =>
      addr.name && addr.name.trim().toLowerCase() === addressTypeTrimmed
    );
  }




}
